import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { RoleService } from './../../../../management/shared/services/roleService';
// Angular
import { Component, OnInit } from '@angular/core';
// RxJS
import { Observable } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { currentUser, Logout, User } from '../../../../../core/auth';
import { Router } from '@angular/router';


@Component({
	selector: 'kt-user-profile',
	templateUrl: './user-profile.component.html',
	styleUrls: ['./user-profile.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserProfileComponent implements OnInit {
	// Public properties
	user: User;
loding:boolean=true;
	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 */
	constructor(private store: Store<AppState>,
		private router: Router,
		private roleService: RoleService,
		private changeDetectorRef: ChangeDetectorRef,
	) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.store.pipe(select(currentUser)).subscribe((res) => {
			this.user = res;
			this.loding=false;
			this.changeDetectorRef.markForCheck();
		});
	
	}

	/**
	 * Log out
	 */
	logout() {
		this.store.dispatch(new Logout());
	}

	isAdmin() {
		if (this.roleService.haveRole('ViewMenu_UserManagement'))
			return true;
	}

	adminUrl() {
		if (this.roleService.haveRole('Read_AdminAll'))
			return '/admin/dashboard';
		else if (this.roleService.haveRole('Read_Orders'))
			return '/admin/purchases';
		else if (this.roleService.haveRole('Support_Ticket'))
			return '/admin/tickets';
		else if (this.roleService.haveRole('Read_Reseller'))
			return '/admin/reseller';
		else if (this.roleService.haveRole('Read_CustomerRelation'))
			return 'admin/crmcustomers';
	}

	goLogin(){
		this.router.navigateByUrl('/auth/login');
	}
}
